"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const utils_1 = require("../../utils/utils");
const styles_1 = __importDefault(require("../../styles/styles"));
const DefaultProps = {
    style: styles_1.default.textTitle,
};
const AmountComponent = ({ amount, style }) => {
    const numberinNaira = (amount / 100).toFixed(2);
    const formattedAmount = utils_1.formatNumber(numberinNaira);
    return react_1.default.createElement(react_native_1.Text, { style: style }, `₦ ${formattedAmount}`);
};
AmountComponent.defaultProps = DefaultProps;
exports.default = AmountComponent;
